import React from "react";
import { useParams } from "react-router-dom";

import { useContacts } from "@/api/queries/contacts";
import LoadingWrapper from "@/components/loading-wrapper";

import { Table } from "../../components/Table";
import { CONTACTS_COLUMNS } from "../../config/contactsTable";

function AccountContacts() {
  const { accountId } = useParams<{
    accountId: string;
  }>();

  const { data, isLoading, error } = useContacts(Number(accountId));

  return (
    <LoadingWrapper
      loading={isLoading}
      loadingLayout="table"
      errorText={error && "There was an issue loading the account contacts"}
    >
      <Table
        responsive
        addRowText="Add New Contact +"
        columns={CONTACTS_COLUMNS}
        rows={data?.contacts}
      />
    </LoadingWrapper>
  );
}

export { AccountContacts };
